import React, { useContext } from 'react';
import { Table, EllipsisDropdown } from 'dyl-components';
import { Icon, Checkbox, DropdownItem } from 'semantic-ui-react';
import { PhoneUtil, StringUtils } from 'utils';
import { BulkActionsContext } from 'shared/context/BulkActionsProvider';
import { USER_PERMISSIONS } from 'dyl-components';
import RestrictedView from 'shared/RestrictedView';

import '../index.scss';
import Destinations from './Destinations';

const CAPABILTY_ICONS = {
    Voice: "fas fa-phone",
    SMS: "fas fa-phone",
    MMS: "fas fa-phone",
    Fax: "fa-solid fa-fax"
}

const CAPABILTY_TEXT = {
    SMS: "SMS",
    MMS: "MMS",
}

const Row = ({ number = {}, onOpenEditDylNumberModal, isPhoneTab, onNewNumber }) => {
    const { number: phoneNumber, capability, type, destination, label, cid_name_replace, cnam, isEditDisable = false, subscription_id } = number;
    const bulkActions = useContext(BulkActionsContext);
    const [selectedNumbers, setSelectedNumbers] = bulkActions || [[], () => {}]; 

    const isSelected = (dyl_number_id) => {
        return selectedNumbers.includes(dyl_number_id);
    }

    const onToggleNumber = (dyl_number_id) => {
        const newSelectedNumbers = isSelected(dyl_number_id) ? selectedNumbers.filter(id => dyl_number_id !== id) : [...selectedNumbers, dyl_number_id];
        setSelectedNumbers(newSelectedNumbers);
    }

    const fomatType = (type)=>{
        switch(type){
            case "local_number":
                return "Local";
            case "port_in_local_number":
                return <>Local <br/> (Porting)</>;
            case "toll_free_number":
                return "Toll Free";
            case "port_in_toll_free_number":
                return <>Toll-Free <br/> (Porting)</>;
            case "free_local_number":
                return <>Local<br/> Included<br/> (Porting)</>;
            default:
                return StringUtils.capitalize(type);
        }
    }
    return (
        <Table.Row>
            {!isPhoneTab && <Table.Cell>
                <Checkbox checked={isSelected(phoneNumber)} onChange={() => { onToggleNumber(phoneNumber) }} disabled />
            </Table.Cell>}
            <Table.Cell>
                {
                    phoneNumber && (
                        <>
                            {PhoneUtil.formatPhoneNumber(phoneNumber)}
                            <Icon className={`${CAPABILTY_ICONS["Voice"]}`} style={{ marginLeft: 50, marginRight: 10 }} />
                            {CAPABILTY_TEXT[capability]}
                        </>
                    )
                }
            </Table.Cell>
            <Table.Cell>
                {fomatType(type)}
            </Table.Cell>
            <Table.Cell>
                <Destinations destination={destination} />
            </Table.Cell>
            <Table.Cell>
                {label}
            </Table.Cell>
            <Table.Cell>
                {cid_name_replace}
            </Table.Cell>
            <Table.Cell>
                {cnam}
            </Table.Cell>
           {!isPhoneTab && <Table.Cell>
                <EllipsisDropdown>
                    <RestrictedView type='disabled' userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_EDIT}>
                        <DropdownItem
                            text={"Edit"}
                            icon={"fa-solid fa-pencil"}
                            disabled={isEditDisable}
                        onClick={() => onOpenEditDylNumberModal(phoneNumber)}
                        />
                    </RestrictedView>
                    <DropdownItem
                        text={"New Number"}
                        disabled={phoneNumber?.length > 0}
                        icon={"fas fa-square-phone"}
                        onClick={() => onNewNumber(type, subscription_id)}
                    />
                </EllipsisDropdown>      
            </Table.Cell>}
        </Table.Row>
    );
}

export default Row;


